import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { useSuppliersallQuery } from "../../../services/supplierApi";
import { signInUser } from "../../Utility/Auth";
import customStyles from "./SelectFeild";

const SelectSupplier = ({ selected, handleOnchange }) => {
  const auth = signInUser();
  const { aamarId } = auth || {};

  // Fetch data using RTK Query
  const { data, isSuccess, isLoading } = useSuppliersallQuery({ aamarId });

  // State for the dropdown options
  const [options, setOptions] = useState([
    { value: "0", label: "Select Supplier" },
  ]);
  const [internalSelected, setInternalSelected] = useState(null);

  // Update options when data is fetched successfully
  useEffect(() => {
    if (isSuccess && data?.length > 0) {
      const supplierList = data.map((item) => ({
        ...item,
        value: item._id,
        option: item._id,
        label: item.company,
      }));
      setOptions(supplierList);
    } else if (isSuccess) {
      setOptions([{ value: "0", label: "Select Supplier" }]);
    }
  }, [data, isSuccess]);

  // Set the selected value (support object { value }, string id, or internal state if uncontrolled)
  const selectedVal =
    selected !== undefined
      ? selected?.value !== undefined
        ? selected.value
        : selected
      : internalSelected?.value || internalSelected?.option;

  const selectedOption = selectedVal
    ? options.find(
        (opt) =>
          opt.value === selectedVal ||
          opt.option === selectedVal ||
          opt._id === selectedVal
      ) || null
    : null;

  const handleChange = (selectedOpt) => {
    setInternalSelected(selectedOpt);
    if (handleOnchange) {
      handleOnchange(selectedOpt);
    }
  };

  return (
    <Fragment>
      <Select
        className="select"
        placeholder="Select Supplier"
        isLoading={isLoading}
        isClearable={true}
        value={selectedOption}
        isSearchable={true}
        name="supplier_code"
        onChange={handleChange}
        options={options}
        styles={customStyles}
      />
    </Fragment>
  );
};

export default SelectSupplier;
